<template>
  <div>
    <div class="block1">
      <template v-if="$slots.default">
        <div @click="openGlobalModal">
          <slot/>
        </div>
      </template>
      <template v-else>
        <LoadingButton
          title='<i class="icon-fa icon-fa-microphone-slash text-center"></i>'
          className="btn btn-dark btn-lg"
          :onClick="() => openGlobalModal()"
          :loading="loading"
          color="black"
        />
      </template>
      <!--        :onClick="() => this.open = true"-->
      <span v-if="blackList && blackList.comments" class="badge-number badge badge-danger">{{ blackList.comments.length }}</span>
    </div>

    <PhoneBlackListEditModal
      v-if="open"
      :newRecord="blackList || {phone_num: phone.full_phone}"
      :onCancel="(comment) => this.closeModal(comment)"
    />

  </div>
</template>

<script>

import LoadingButton from '@/components/buttons/LoadingButton'
import PhoneBlackListEditModal from '@/components/clients/PhoneBlackListEditModal'
import store from "@/store";

export default {
  props: ['phone', 'blackList', 'updatePhoneRecord'],
  components: {
    LoadingButton,
    PhoneBlackListEditModal,
  },
  data() {
    return {
      open: false,
      loading: false,
      localList: null,
    }
  },
  mounted() {
  },
  methods: {
    openGlobalModal() {
      store.dispatch("platform/setGlobalModalData", {
        ...{
          type: 'clientPhoneBlackList',
          blackListPhoneNum: this.phone?.black_list?.phone_num,
          newRecord: this.blackList || {phone_num: this.phone.black_list?.phone_num || this.phone.full_phone},
          onCancel: (comment) => this.closeModal(comment)
        }
      });
    },
    closeModal(comment = null) {
      this.open = false
      if (comment && this.blackList) {
        this.blackList.comments.push(comment)
      }
    },
    openModal() {

    }
  }
}

</script>

<style scoped>
.block1 {
  position: relative;
}

.btn {
  border-radius: 0;
}

.block {
  position: relative;
}

.badge-number {
  top: -5px;
  position: absolute;
  z-index: 9;
  right: 0;
}
</style>
